import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/customer/customer.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { CustomerService } from '@ng/core/customer/customer.service';

export const CustomerServiceModule = angular.module('acme.common.service.customer', []).name;
